module.exports = "//static.hsappstatic.net/marketplace-ui-common/static-1.7411/img/storefront-header-blobs.svg"